import React from 'react';

const GameLimbo = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19 21.75H5V20.25H19V21.75ZM20 5.25C20.9665 5.25 21.75 6.0335 21.75 7V17C21.75 17.9665 20.9665 18.75 20 18.75H4C3.0335 18.75 2.25 17.9665 2.25 17V7C2.25 6.0335 3.0335 5.25 4 5.25H20ZM4 6.75C3.86193 6.75 3.75 6.86193 3.75 7V17C3.75 17.1381 3.86193 17.25 4 17.25H20C20.1381 17.25 20.25 17.1381 20.25 17V7C20.25 6.86193 20.1381 6.75 20 6.75H4ZM12 10.7988L13.8389 8.5H15.7607L12.9609 12L15.7607 15.5H13.8389L12 13.2012L10.1611 15.5H8.23926L11.0391 12L8.23926 8.5H10.1611L12 10.7988ZM19 3.75H5V2.25H19V3.75Z",
      fill: "white"
    }
  )
);

export { GameLimbo };
//# sourceMappingURL=GameLimbo.js.map
